import { useEffect, useSyncExternalStore } from 'react';

type BackAction = { onBack: () => void; disabled?: boolean } | undefined;

let currentBackAction: BackAction;
const listeners = new Set<() => void>();

export const setApplicationBackAction = (action: BackAction): void => {
  currentBackAction = action;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): BackAction => currentBackAction;

export const useApplicationBackAction = (): BackAction =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export const useRegisterApplicationBackAction = (onBack?: () => void, disabled?: boolean): void => {
  useEffect(() => {
    if (!onBack) {
      setApplicationBackAction(undefined);
      return;
    }
    setApplicationBackAction({ onBack, disabled });
    return () => setApplicationBackAction(undefined);
  }, [onBack, disabled]);
};
